import { Image } from "antd";
import moment from "moment";
import { INPUT_TYPES, PLACEHOLDER } from "../../../config";
import { getImageUploadViewValue } from "../../../../../../helpers/form";

export const renderInputView = ({ input, data, t }) => {
  switch (input.type) {
    case INPUT_TYPES.IMAGE_UPLOAD:
      const value = data[input.key];
      let fileList = getImageUploadViewValue(value);

      return fileList.length ? (
        <div className="image-container">
          {fileList.filter(f => f.url).map(v => (
            <Image
              width={200}
              src={v.url}
            />
          ))}
        </div>
      ) : typeof value !== 'object' ? (
        <div className="value">
          {value || PLACEHOLDER}
        </div>
      ) : (
        <div className="value">
          {PLACEHOLDER}
        </div>
      );
    case INPUT_TYPES.SELECT:
      const _v = (input.options || []).find((v) => v.value === data[input.key]);

      if (_v) {
        return (
          <div className="value">
            {_v.label || PLACEHOLDER}
          </div>
        )
      }

      return (
        <div className="value">
          {PLACEHOLDER}
        </div>
      );
    case INPUT_TYPES.SWITCH:
      return (
        <div className="value">
          {t(!(data[input.key] || input.defaultChecked) ? 'Off' : 'On')}
        </div>
      );
    case INPUT_TYPES.RESET_PASSWORD:
      return (
        <div className="value">
          {data.passwordChangedAt ? moment(data.passwordChangedAt).format('DD MMM YYYY') : '--'}
        </div>
      );
    case INPUT_TYPES.TRANSFER_RIGHTS:
      return (
        <div className="value">
          {data.companyEmail || PLACEHOLDER}
        </div>
      )
    default:
      return (
        <div className="value">
          {typeof data[input.key] === 'string' ? data[input.key] || PLACEHOLDER : PLACEHOLDER}
        </div>
      )
  }
}
